import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../redux';
import SwitchWithInput from '../SwitchWithInput';
import SliderWithInput from '../SliderWithInput';
import {
  updateCrossTabStyleOptions,
  updateLayoutOptions,
} from '../../../redux/ChartPoperties/ChartControlsActions';
import { Tooltip } from '@mui/material';

const RenderManualLayoutControls = ({
  propKey,
  iconColor,
}: {
  propKey: string;
  iconColor?: string;
}) => {
  const dispatch = useDispatch();

  const { chartProperties, chartControls } = useSelector((state: RootState) => ({
    chartProperties: state.chartProperties,
    chartControls: state.chartControls,
  }));

  const measureFields = chartProperties.properties[propKey]?.chartAxes?.find(
    (axis: any) => axis.name === 'Measure',
  );
  const measureFieldsNames = measureFields
    ? measureFields.fields.map((field: any) => field.displayname)
    : [];
  const rowFields = chartProperties.properties[propKey]?.chartAxes?.find(
    (axis: any) => axis.name === 'Row',
  );
  const rowFieldsNames = rowFields ? rowFields.fields.map((field: any) => field.displayname) : [];
  const colFields = chartProperties.properties[propKey]?.chartAxes?.find(
    (axis: any) => axis.name === 'Column',
  );
  const colFieldsNames = colFields ? colFields.fields.map((field: any) => field.displayname) : [];

  const customWidth = chartControls.properties[propKey]?.layoutOptions?.customWidth || {};
  const customHeight = chartControls.properties[propKey]?.layoutOptions?.customHeight || {};

  const minCellHeight =
    chartControls.properties[propKey].crossTabCellLabelOptions.fontSize * 1.25 + 3;
  const minHeaderHeight =
    chartControls.properties[propKey].crossTabHeaderLabelOptions.fontSize * 1.25 + 3;

  const manualWidth: boolean =
    chartControls.properties[propKey]?.layoutOptions?.manualWidth || false;
  const manualHeight: boolean =
    chartControls.properties[propKey]?.layoutOptions?.manualHeight || false;

  const updateColumnWidth = (colName: string, width: number) => {
    dispatch(
      updateLayoutOptions(propKey, 'customWidth', {
        ...customWidth,
        [colName]: width,
      }),
    );
  };

  return (
    <>
      <div>
        <>
          <div
            className="optionDescription"
            style={{
              marginTop: '0',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              color: iconColor ? iconColor : '#404040',
            }}
          >
            Manual Width
            {manualWidth === true && (
              <span style={{ display: 'flex', alignItems: 'center', marginLeft: 'auto' }}>
                <Tooltip
                  title="Reset"
                  slotProps={{
                    tooltip: {
                      sx: {
                        fontSize: '12px',
                      },
                    },
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    className="lucide lucide-eraser-icon lucide-eraser"
                    onClick={() => {
                      dispatch(updateLayoutOptions(propKey, 'customWidth', {}));
                    }}
                  >
                    <path d="M21 21H8a2 2 0 0 1-1.42-.587l-3.994-3.999a2 2 0 0 1 0-2.828l10-10a2 2 0 0 1 2.829 0l5.999 6a2 2 0 0 1 0 2.828L12.834 21" />
                    <path d="m5.082 11.09 8.828 8.828" />
                  </svg>
                </Tooltip>
              </span>
            )}
            <div style={{ transform: 'translateX(60px)', paddingLeft: '5px' }}>
              <SwitchWithInput
                isChecked={manualWidth}
                onSwitch={() => dispatch(updateLayoutOptions(propKey, 'manualWidth', !manualWidth))}
              />
            </div>
          </div>
          {manualWidth === true && (
            <>
              {rowFieldsNames.map((displayName: string, index: number) => {
                return (
                  <>
                    <div
                      className="optionDescription"
                      style={{ marginTop: '0', color: iconColor ? iconColor : '#404040' }}
                    >
                      {/* {displayName} */}
                      Header Column {index + 1}
                    </div>
                    <SliderWithInput
                      percent={false}
                      sliderValue={customWidth[displayName] || 80}
                      sliderMinMax={{ min: 80, max: 300, step: 1 }}
                      changeValue={(value) => updateColumnWidth(displayName, value)}
                    />
                  </>
                );
              })}
              {rowFieldsNames.length === 0 && colFieldsNames.length > 0 && (
                <>
                  <div
                    className="optionDescription"
                    style={{ marginTop: '0', color: iconColor ? iconColor : '#404040' }}
                  >
                    {/* {displayName} */}
                    Header Column 1
                  </div>
                  <SliderWithInput
                    percent={false}
                    sliderValue={customWidth[colFieldsNames[0]] || 80}
                    sliderMinMax={{ min: 80, max: 300, step: 1 }}
                    changeValue={(value) => updateColumnWidth(colFieldsNames[0], value)}
                  />
                </>
              )}
              {measureFieldsNames.length === 0 && (
                <>
                  <div style={{ paddingBottom: '10px' }}>
                    <div
                      className="optionDescription"
                      style={{ marginTop: '0', color: iconColor ? iconColor : '#404040' }}
                    >
                      Cell width
                    </div>
                    <SliderWithInput
                      percent={false}
                      sliderValue={
                        chartControls.properties[propKey].crossTabStyleOptions.lineWidth || 80
                      }
                      sliderMinMax={{ min: 80, max: 300, step: 1 }}
                      changeValue={(value) =>
                        dispatch(updateCrossTabStyleOptions(propKey, 'lineWidth', value))
                      }
                    />
                  </div>
                </>
              )}
              {measureFieldsNames.map((displayName: string) => {
                return (
                  <>
                    <div
                      className="optionDescription"
                      style={{ marginTop: '0', color: iconColor ? iconColor : '#404040' }}
                    >
                      {displayName}
                    </div>
                    <SliderWithInput
                      percent={false}
                      sliderValue={customWidth[displayName] || 80}
                      sliderMinMax={{ min: 80, max: 300, step: 1 }}
                      changeValue={(value) => updateColumnWidth(displayName, value)}
                    />
                  </>
                );
              })}
            </>
          )}
        </>
        <>
          <div
            className="optionDescription"
            style={{
              marginTop: '5px',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              color: iconColor ? iconColor : '#404040',
            }}
          >
            Manual Height
            {manualHeight === true && (
              <span style={{ display: 'flex', alignItems: 'center', marginLeft: 'auto' }}>
                <Tooltip
                  title="Reset"
                  slotProps={{
                    tooltip: {
                      sx: {
                        fontSize: '12px',
                      },
                    },
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    className="lucide lucide-eraser-icon lucide-eraser"
                    onClick={() => {
                      dispatch(updateLayoutOptions(propKey, 'customHeight', {}));
                      dispatch(updateCrossTabStyleOptions(propKey, 'lineHeight', minCellHeight));
                    }}
                  >
                    <path d="M21 21H8a2 2 0 0 1-1.42-.587l-3.994-3.999a2 2 0 0 1 0-2.828l10-10a2 2 0 0 1 2.829 0l5.999 6a2 2 0 0 1 0 2.828L12.834 21" />
                    <path d="m5.082 11.09 8.828 8.828" />
                  </svg>
                </Tooltip>
              </span>
            )}
            <div style={{ transform: 'translateX(60px)', paddingLeft: '5px' }}>
              <SwitchWithInput
                isChecked={manualHeight}
                onSwitch={() =>
                  dispatch(updateLayoutOptions(propKey, 'manualHeight', !manualHeight))
                }
              />
            </div>
          </div>
          {manualHeight === true && (
            <>
              <div style={{ paddingBottom: '10px' }}>
                <div
                  className="optionDescription"
                  style={{ marginTop: '0', color: iconColor ? iconColor : '#404040' }}
                >
                  Line Height
                </div>
                <SliderWithInput
                  percent={false}
                  sliderValue={
                    chartControls.properties[propKey].crossTabStyleOptions.lineHeight ||
                    minCellHeight
                  }
                  sliderMinMax={{
                    min: minCellHeight,
                    max: 85,
                    step: 1,
                  }}
                  changeValue={(value) =>
                    dispatch(updateCrossTabStyleOptions(propKey, 'lineHeight', value))
                  }
                />
              </div>
              {colFieldsNames.map((displayName: string, index: number) => {
                if (
                  measureFieldsNames.length === 0 &&
                  rowFieldsNames.length > 0 &&
                  index === colFieldsNames.length - 1
                ) {
                  return null;
                }
                return (
                  <>
                    <div
                      className="optionDescription"
                      style={{ marginTop: '0', color: iconColor ? iconColor : '#404040' }}
                    >
                      {/* {displayName} */}
                      Header Row {index + 1}
                    </div>
                    <SliderWithInput
                      percent={false}
                      sliderValue={customHeight[index + 1] || minHeaderHeight}
                      sliderMinMax={{
                        min: minHeaderHeight,
                        max: 85,
                        step: 1,
                      }}
                      changeValue={(value) => {
                        dispatch(
                          updateLayoutOptions(propKey, 'customHeight', {
                            ...customHeight,
                            [index + 1]: value,
                          }),
                        );
                      }}
                    />
                  </>
                );
              })}
              {rowFieldsNames.length > 0 ? (
                <>
                  <div
                    className="optionDescription"
                    style={{ marginTop: '0', color: iconColor ? iconColor : '#404040' }}
                  >
                    {/* {rowFieldsNames[0]} */}
                    Header Row{' '}
                    {measureFieldsNames.length === 0 && colFieldsNames.length
                      ? colFieldsNames.length
                      : colFieldsNames.length + 1}
                  </div>
                  <SliderWithInput
                    percent={false}
                    sliderValue={
                      customHeight[
                        measureFieldsNames.length === 0 && colFieldsNames.length
                          ? colFieldsNames.length
                          : colFieldsNames.length + 1
                      ] || minHeaderHeight
                    }
                    sliderMinMax={{
                      min: minHeaderHeight,
                      max: 85,
                      step: 1,
                    }}
                    changeValue={(value) => {
                      dispatch(
                        updateLayoutOptions(propKey, 'customHeight', {
                          ...customHeight,
                          [measureFieldsNames.length === 0 && colFieldsNames.length
                            ? colFieldsNames.length
                            : colFieldsNames.length + 1]: value,
                        }),
                      );
                    }}
                  />
                </>
              ) : (
                measureFieldsNames.length > 0 && (
                  <>
                    <div
                      className="optionDescription"
                      style={{ marginTop: '0', color: iconColor ? iconColor : '#404040' }}
                    >
                      {/* {measureFieldsNames[0]} */}
                      Header Row {colFieldsNames.length + 1}
                    </div>
                    <SliderWithInput
                      percent={true}
                      sliderValue={customHeight[colFieldsNames.length + 1] || minHeaderHeight}
                      sliderMinMax={{
                        min: minHeaderHeight,
                        max: 85,
                        step: 1,
                      }}
                      changeValue={(value) => {
                        dispatch(
                          updateLayoutOptions(propKey, 'customHeight', {
                            ...customHeight,
                            [colFieldsNames.length + 1]: value,
                          }),
                        );
                      }}
                    />
                  </>
                )
              )}
            </>
          )}
        </>
      </div>
    </>
  );
};

export default RenderManualLayoutControls;
